"use client";

import React from 'react';

const benefits = [
  {
    icon: "💰",
    title: "Bezpłatna wycena",
    desc: "Szczegółowa wycena bez żadnych ukrytych kosztów. Przyjedziemy i ocenimy obiekt na miejscu."
  },
  {
    icon: "⚡",
    title: "Szybki montaż",
    desc: "Większość instalacji realizujemy w ciągu 1-3 dni. Minimalne zakłócenia w codziennej pracy."
  },
  {
    icon: "📱",
    title: "Podgląd na telefonie",
    desc: "Konfigurujemy aplikację mobilną, powiadomienia push i dostęp zdalny w dniu montażu."
  },
  {
    icon: "🛡️",
    title: "Gwarancja i wsparcie",
    desc: "2 lata gwarancji na sprzęt i instalację + całodobowe wsparcie techniczne."
  },
  {
    icon: "🔧",
    title: "Profesjonalny dobór sprzętu",
    desc: "Nie sprzedajemy „standardowego zestawu”. Dobór kamer do konkretnego obiektu i potrzeb."
  }
];

export default function WhyChooseUs() {
  const scrollToContact = () => {
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="dlaczego-my" className="max-w-screen-2xl mx-auto px-8 py-20">
      <div className="text-center mb-12">
        <div className="text-blue-500 font-semibold tracking-[2px] text-sm mb-2">DLACZEGO MY</div>
        <h2 className="text-4xl md:text-5xl font-semibold tracking-tighter">Dlaczego warto wybrać DaHaka?</h2>
        <p className="mt-4 text-xl text-zinc-400 max-w-2xl mx-auto">
          Nie montujemy kamer „na oko”. Tworzymy skuteczne systemy bezpieczeństwa.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {benefits.map((benefit, index) => (
          <div key={index} className="dark-card rounded-3xl p-7 flex flex-col">
            <div className="text-4xl mb-4">{benefit.icon}</div>
            <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
            <p className="text-zinc-400 flex-1">{benefit.desc}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <button 
          onClick={scrollToContact}
          className="inline-flex items-center gap-x-2 px-8 py-4 bg-blue-600 hover:bg-blue-500 active:bg-blue-700 transition-colors rounded-3xl font-semibold text-lg"
        >
          Zamów bezpłatną wycenę
        </button>
      </div>
    </section>
  );
}
